module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "extraInfo"
  }, [_c('p'), (_vm.activity.translations[_vm.language].included) ? _c('div', {
    staticClass: "included m-t-2"
  }, [_c('h4', [_vm._v(_vm._s(_vm.t('What\'s included')))]), _vm._v(" "), _vm._l((_vm.activity.translations[_vm.language].included.split('\n')), function(line) {
    return _c('div', [_c('p', [_vm._v(_vm._s(line))])])
  })], 2) : _vm._e(), _vm._v(" "), (_vm.activity.translations[_vm.language].aditional_services) ? _c('div', {
    staticClass: "aditionalServices m-t-2 p-b-1"
  }, [_c('h4', [_vm._v(_vm._s(_vm.t('Aditional services')))]), _vm._v(" "), _vm._l((_vm.activity.translations[_vm.language].aditional_services.split('\n')), function(line) {
    return _c('div', [_c('p', [_vm._v(_vm._s(line))])])
  })], 2) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "m-t-2 cancelationDays m-b-1"
  }, [_c('i', {
    staticClass: "fa fa-ban"
  }), _vm._v("\n      " + _vm._s(_vm.t('Free cancellation')) + " "), _c('b', [_vm._v(_vm._s(_vm.activity.cancelation_days))]), _vm._v(" "), (_vm.activity.cancelation_days != 1) ? _c('span', [_vm._v(_vm._s(_vm.t('days')))]) : _c('span', [_vm._v(_vm._s(_vm.t('day')))]), _vm._v(" " + _vm._s(_vm.t('in advance.')))]), _vm._v(" "), _c('div', {
    staticClass: "bookingInfo"
  }, [_c('i', {
    staticClass: "fa fa-info-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n      " + _vm._s(_vm.t('All booking information including promoter data and meeting point are included in your booking confirmation voucher.')) + "\n    ")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7f285d39", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f285d39"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Activity/ActivityExtraInfo.vue
// module id = 794
// module chunks = 3